import React, {useEffect, useState} from 'react';
import SetPasswordComponent from "../components/SetPasswordComponent";
import {useLocation} from "react-router-dom";
import queryString from "query-string";
import * as mainActions from "../../../actions/actions";
import mainStore from "../../../stores/mainStore";


const SetPassword = () => {
  const { search } = useLocation();
  
  const [form, setForm] = useState({
    password: {
      value: '',
      valid: false,
      touched: false,
    },
    re_password: {
      value: '',
      valid: false,
      touched: false,
    },
    token: '',
  });
  const [token, setToken] = useState('');
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    const values = queryString.parse(search);
  
    setToken(values.token);
  }, [search]);
  
  useEffect(() => {
    mainStore.once('change', () => {
      const {data} = mainStore.state.setPasswordResponse;
  
      setLoading(false);
      
      if (data.data.title === 'Done') {
        mainStore.setCookie("tm-access-token", data.data.access_token,1);
        window.location = data.data.redirect_url;
      }
    });
  }, []);
  
  const validateField = (value) => {
    return value.length > 7;
  };
  
  const onChange = (e) => {
    const {value, name} = e.target;
    
    setForm({
      ...form,
      [name]: {
        value,
        valid: validateField(value),
        touched: true,
      }
    })
  }
  const onSubmit = () => {
    if (form.password.value === form.re_password.value) {
      setLoading(true);
      
      const data = {
        password: form.password.value,
        re_password: form.re_password.value,
        token: token,
      }
      mainActions.setPassword(data);
      
      return;
    }
    
    setForm({
      ...form,
      password: {
        ...form.password,
        valid: false,
      },
      re_password: {
        ...form.re_password,
        valid: false,
      },
    })
  };
  
  return (
      <SetPasswordComponent
          form={form}
          loading={loading}
          onChange={onChange}
          onSubmit={onSubmit}
      />
  );
};

export default SetPassword;